import React from 'react';

const SkillIcon = (props) => {
    return (
        <>

            <ul className="list-inline dev-icons">
                {props.icons.map((e, index) => (
                    <li key={index} className="list-inline-item">
                        <i className={e}></i>
                    </li>))}

            </ul>

        </>
    );
}

export default SkillIcon;